'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _limelight = require('@dotdev/limelight');

var _limelight2 = _interopRequireDefault(_limelight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var limelightAccordions = function limelightAccordions() {
  window.accordionWrappers = [];

  var updateAccordions = function updateAccordions() {
    var startingIndex = accordionWrappers.length;
    var accordions = document.querySelectorAll('[data-trigger="accordion"]');

    accordions.forEach(function (element, index) {
      var i = startingIndex + index;

      if (!element.classList.contains('limelight-initialised')) {
        var visible = false;
        if (element.classList.contains('active')) {
          visible = true;
        }
        accordionWrappers[i] = new _limelight2.default('' + element.dataset.target, {
          visible: visible,
          slide: true,
          slideSpeed: 250,
          triggerClass: 'active',
          beforeShowCallback: function beforeShowCallback(element, elements) {
            accordionWrappers.forEach(function (accordion, ind) {
              _limelight2.default.elements[accordion.target].hide();
            });
          }
        });
        element.classList.add('limelight-initialised');
      }
    });
  };

  document.addEventListener('accordions:update', updateAccordions);
  updateAccordions();
};

exports.default = limelightAccordions;